/* tslint:disable */
/* eslint-disable */
/**
 * NameCheck API
 * assembly version: 1.0.0.0
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SiteDto,
    SiteDtoFromJSON,
    SiteDtoFromJSONTyped,
    SiteDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdatePositionDto
 */
export interface UpdatePositionDto {
    /**
     * 
     * @type {number}
     * @memberof UpdatePositionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePositionDto
     */
    positionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePositionDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePositionDto
     */
    comment?: string | null;
    /**
     * 
     * @type {Array<SiteDto>}
     * @memberof UpdatePositionDto
     */
    sites?: Array<SiteDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePositionDto
     */
    isActive?: boolean;
}

export function UpdatePositionDtoFromJSON(json: any): UpdatePositionDto {
    return UpdatePositionDtoFromJSONTyped(json, false);
}

export function UpdatePositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePositionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'positionCode': !exists(json, 'positionCode') ? undefined : json['positionCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'sites': !exists(json, 'sites') ? undefined : (json['sites'] === null ? null : (json['sites'] as Array<any>).map(SiteDtoFromJSON)),
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}

export function UpdatePositionDtoToJSON(value?: UpdatePositionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'positionCode': value.positionCode,
        'name': value.name,
        'comment': value.comment,
        'sites': value.sites === undefined ? undefined : (value.sites === null ? null : (value.sites as Array<any>).map(SiteDtoToJSON)),
        'isActive': value.isActive,
    };
}


